module.exports = __webpack_public_path__ + "img/11.06d485e5.jpg";